/**
 * Resolves a PRIVATE_URIS template against the current username.
 * Handles both username-templated routes ('user/:username/feed' → '/user/aelius/feed')
 * and absolute routes ('/moderation/queue' → '/moderation/queue').
 * Ensures leading slash so React Router treats it as absolute.
 */
export function resolveNavRoute(
  template: string,
  username: string | null | undefined,
): string {
  const replaced = username
    ? template.replaceAll(':username', username)
    : template;
  return replaced.startsWith('/') ? replaced : `/${replaced}`;
}

/**
 * Returns true if `pathname` matches the resolved route either exactly or as
 * a directory prefix. Avoids substring-collision bugs like '/posts' matching
 * '/post-reply-draft/xyz'.
 */
export function isRouteActive(
  pathname: string,
  resolvedRoute: string,
): boolean {
  if (pathname === resolvedRoute) return true;
  // Append a '/' to the route so '/posts' doesn't match '/post-reply-draft'.
  return pathname.startsWith(`${resolvedRoute}/`);
}
